import React, { useState } from "react"

import { sanitizeTextForAnalytics } from "@/utils/helper"

import CONSTANTS from "@/constants"
import { NumericFormat } from "react-number-format"
import htmlParser from "html-react-parser"
import style from "@/components/ProductDetail/v3/ProductDetailView/productDetailsView.module.scss"
import ProductAccordionList from "@/components/ProductDetail/v3/ProductAccordionList"
import useWindowResize from "@/hooks/useWindowResize"

const Loader = props => {
  const {
    test,
    pdpData: productInfo,
    skuId,
    initialImgAlt,
    initialImgUrl,
    config = {},
    isDiscontinued = false,
    staticTexts = {},
    sku = "",
    ProductPriceSpiderIncluded_s = false,
    currencySign = "",
    persona = "",
    addToCartProps: { specialOrder = "", backOrder = "" } = {},
    isProjectPack = "",
    disableEcommerce = true,
    productAnalyticsData = {},
    replaceAddToCart = false,
    disableRatings = false,
    replaceAddToCartCtaLink = "",
    replaceAddToCartCtaLabel = "",
    linkNewTab = false,
    pdpJson = {},
    productType = "",
    installationDataFromProp = [],
    designServiceDataFromProp = [],
    installationData = [],
    locale = "",
    productData = {},
    businessUnitName = "",
    discontinuedProductb = "",
    ProductRequiredAccessoriesGroupsList = [],
    superSku = "",
    designServiceData = [],
    productServices = [],
    getZipCode = () => {},
    currencyCode = "",
  } = props

  const [width, height] = useWindowResize()

  const {
    ProductBrandName_s: pdpBrnadName = "",
    ProductDescriptionProductShort_s: pdpShotDesc = "",
    sku_s: productID = "",
    ProductLocalCategory_s: productCategory = "",
    masterSKU_s: masterSku = "",
    "priceList.ANY.finalPrice_d": anyFinalPrice = "",
    "priceList.GST.finalPrice_d": gstFinalPrice = "",
    ProductNarrativeDescription_s: ProductNarrativeDescription_s,
    productName_s: productName = "",
    "Color.GST.Details_ss": colorDetails = [],
  } = productInfo

  const variant = colorDetails.find(item => item.startsWith(skuId))
  const variantData = variant ? variant.split("|") : []
  let discountedPrice = 0
  let price = 0

  if (variantData.length > 0) {
    discountedPrice = variantData[3]
    price = variantData[2]
  } else {
    discountedPrice = gstFinalPrice
    price = anyFinalPrice
  }

  const discountPercent = Math.round(((price - discountedPrice) / price) * 100)
  const { pdpDesktopImage, pdpMobileImage } = pdpJson
  const [initImage] = useState(
    pdpDesktopImage && initialImgUrl
      ? pdpDesktopImage
          .replace("/}", `/${initialImgUrl}}`)
          .replace("&fmt=webp", "")
      : ""
  )

  const initMobileImage =
    pdpMobileImage && initialImgUrl
      ? pdpMobileImage
          .replace("/}", `/${initialImgUrl}}`)
          .replace("&fmt=webp", "")
      : ""

  const [initImageAlt] = useState(initialImgAlt)

  const categoryTmp = sanitizeTextForAnalytics(productCategory)
  const category = categoryTmp
    ?.split(" ")
    .map(a => a.charAt(0).toUpperCase() + a?.slice(1))
    .join(" ")

  return (
    <div className={style.productDetailsV3Wrapper}>
      <div
        className="product-detail-page min-vh-100"
        data-testid={"product-detail-page"}
      >
        <div className="container">
          <div className="header-section  kf-react-plp-container">
            <div className="product-detail-page__breadcrumb">
              <nav aria-label="Breadcrumb">
                <ol role="list" style={{ padding: 0 }}>
                  <li role="listitem">
                    <a href="/">{" Home / "}</a>
                  </li>
                  <li role="listitem">
                    <a href="/">{category ? category : "Parts"}</a>
                  </li>
                  <li role="listitem" className="cursor-disabled">
                    {" "}
                    {" / "}
                    <a href="/">
                      {category ? pdpBrnadName || productName : "Parts"}
                    </a>
                  </li>
                </ol>
              </nav>
            </div>
            <div className="product-detail-page__print-share-container">
              <div role="list" className="print-and-share">
                <span role="listitem">
                  <button
                    tabIndex="0"
                    className="gbh-data-layer"
                    data-gbh-data-layer=""
                    data-gbh-data-layer-custom=""
                    aria-label="Click here to print "
                  >
                    <img
                      src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTdweCIgaGVpZ2h0PSIxN3B4IiB2aWV3Qm94PSIwIDAgMTcgMTciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+UHJpbnQtSWNvbjwvdGl0bGU+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iUHJpbnQiIGZpbGw9IiM3NTc1NzUiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNCwwIEwxNCw0IEwxNyw0IEwxNywxMiBMMTQsMTIgTDE0LDE3IEwzLDE3IEwzLDEyIEwwLDEyIEwwLDQgTDMsNCBMMywwIEwxNCwwIFogTTEzLDEyIEw0LDEyIEw0LDE2IEwxMywxNiBMMTMsMTIgWiBNMyw1IEwxLDUgTDEsMTEgTDE2LDExIEwxNiw1IEwxNCw1IEwxNCw4IEwzLDggTDMsNSBaIE0xMywxIEw0LDEgTDQsNyBMMTMsNyBMMTMsMSBaIiBpZD0iUHJpbnQtSWNvbiI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
                      alt=""
                      role="presentation"
                      width="20"
                      height="20"
                    />
                  </button>
                </span>
                <span role="listitem">
                  <button
                    tabIndex="0"
                    aria-label="Click here to share "
                    className="share-button"
                  >
                    <img
                      src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxN3B4IiB2aWV3Qm94PSIwIDAgMTQgMTciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+c2hhcmU8L3RpdGxlPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9InNoYXJlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMC42MjAzNzIpIiBmaWxsPSIjNzU3NTc1IiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICA8cGF0aCBkPSJNMy41LDYuODc5NjI4MyBMMy41LDcuODc5NjI4MyBMMSw3Ljg3OTYyODMgTDEsMTQuODc5NjI4MyBMMTMsMTQuODc5NjI4MyBMMTMsNy44Nzk2MjgzIEwxMC41LDcuODc5NjI4MyBMMTAuNSw2Ljg3OTYyODMgTDE0LDYuODc5NjI4MyBMMTQsMTUuODc5NjI4MyBMMCwxNS44Nzk2MjgzIEwwLDYuODc5NjI4MyBMMy41LDYuODc5NjI4MyBaIE03LC04Ljg4MTc4NDJlLTE2IEw3LjQ0MiwwLjM3OSBMNy41LDAuMzc5NjI4MzAxIEw3LjUsMC40MjgwMDAwMDEgTDEwLjgyNTM5NTcsMy4yNzg5MTA1OSBMMTAuMTc0NjA0Myw0LjAzODE2NzE5IEw3LjUsMS43NDYgTDcuNSwxMS4zNzk2MjgzIEw2LjUsMTEuMzc5NjI4MyBMNi41LDEuNzQ2IEwzLjgyNTM5NTY5LDQuMDM4MTY3MTkgTDMuMTc0NjA0MzEsMy4yNzg5MTA1OSBMNi41LDAuNDI4MDAwMDAxIEw2LjUsMC4zNzk2MjgzMDEgTDYuNTU4LDAuMzc5IEw3LC04Ljg4MTc4NDJlLTE2IFoiIGlkPSJDb21iaW5lZC1TaGFwZSI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
                      alt=""
                      role="presentation"
                      width="20"
                      height="20"
                    />
                  </button>
                </span>
              </div>
            </div>
          </div>
          <div className="product-overview print-overview">
            <div className="product-detail-page__image-gallery print-overview-left">
              <div className="image-reel row">
                <div className="col-12">
                  <div className="pdp-image-reel__image-stack-view">
                    <ul className="pl-0 list-inline pdp-image-reel__image-stack-list">
                      <li className="pdp-image-reel__image-list">
                        <div className="pdp-image-reel__image-display">
                          {initImage ? (
                            <picture>
                              <source
                                srcSet={initMobileImage}
                                media="(max-width: 768px)"
                              />
                              <source
                                srcSet={initImage}
                                media="(min-width: 769px)"
                              />
                              <img
                                role="button"
                                src={initImage}
                                alt={initImageAlt}
                                tabIndex="0"
                                className="print"
                                fetchpriority="high"
                              />
                            </picture>
                          ) : (
                            <p className="shimmer-loading__para shimmer height-400" />
                          )}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="product-detail-page__content-section print-overview-right">
              <div className="row no-gutters product-detail-page__main">
                <div className="col-12">
                  <div className="product-detail-page__price-value">
                    <span>
                      <p className="shimmer-loading__para shimmer width-170"></p>
                    </span>
                  </div>
                  <h1 className="product-detail-page__title-desc">
                    <span className="product-detail-page__title">
                      {pdpBrnadName}
                    </span>
                    <p className="product-detail-page__description">
                      {pdpShotDesc}
                    </p>
                  </h1>
                  <span className="product-detail-page__sku-id">
                    {" "}
                    {productID}
                  </span>
                </div>
              </div>
              <div className="row no-gutters product-detail-page__price-main">
                <div className="col-12 product-detail-page__price">
                  <div
                    className="product-detail-page__price-value"
                    tabIndex="0"
                  >
                    <NumericFormat
                      value={discountedPrice > 0 ? discountedPrice : price}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={CONSTANTS.CURRENCY_SIGN}
                      decimalScale={2}
                      fixedDecimalScale={true}
                    />
                    <div className="product-detail-page__price-alltaxes-text">
                      Inclusive of all taxes
                    </div>
                    {discountedPrice > 0 && discountedPrice !== price && (
                      <div
                        className="col-12 product-detail-page__discount"
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          marginBottom: "10px",
                          marginTop: "10px",
                        }}
                      >
                        <span className="product-detail-page__list-text">
                          MRP
                        </span>
                        <span className="product-detail-page__discount-price">
                          <NumericFormat
                            value={price}
                            displayType="text"
                            thousandSeparator={true}
                            prefix={CONSTANTS.CURRENCY_SIGN}
                            decimalScale={2}
                            fixedDecimalScale={true}
                          />
                        </span>
                        {discountPercent > 0 && (
                          <span className="product-detail-page__percent-off">
                            {discountPercent + "% "}
                            OFF
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="row no-gutters product-detail-page__finish-sample">
                <div className="col-12 product-detail-page__finish">
                  <span className="product-detail-page__finish_value">
                    <p className="shimmer-loading__para shimmer width-170"></p>
                  </span>
                </div>
              </div>
              <div className="row no-gutters product-detail-page__color-swatch-main">
                <div className="col-12 product-detail-page__color-swatch">
                  <div className="color-swatch">
                    <span className="color-swatch">
                      <p className="shimmer-loading__para shimmer"></p>
                    </span>
                  </div>
                  <div className="color-swatch">
                    <span className="color-swatch">
                      <p className="shimmer-loading__para shimmer"></p>
                    </span>
                  </div>
                  <div className="color-swatch">
                    <span className="color-swatch">
                      <p className="shimmer-loading__para shimmer"></p>
                    </span>
                  </div>
                </div>
              </div>
              <div className="row no-gutters width-150">
                <div class="shimmer-loading__para shimmer"></div>
                <p class="shimmer-loading__para shimmer mb20"></p>
                <div class="shimmer-loading__para shimmer shimmer-loading__input"></div>
              </div>
              <div class="row no-gutters buy-area width-150 mb40">
                <div class="shimmer-loading__para shimmer shimmer-loading__input"></div>
              </div>
              <div className="product-detail-page__narrative-description">
                <p className="shimmer-loading__para shimmer  height-fit-content">
                  {ProductNarrativeDescription_s}
                </p>
              </div>
              <div className="product-detail-page__product-accordion-list">
                <p className="shimmer height-60"></p>
                <p className="shimmer height-60"></p>
                <p className="shimmer height-60"></p>
                <p className="shimmer height-60"></p>
                <p className="shimmer height-60"></p>
              </div>
              <div>
                <div className="productonDisplay" id="spendSaveDisplayDiv">
                  <div className="left-side">{pdpJson.productDisplayTitle}</div>
                  <div className="main-right">
                    <div className="right-side">
                      {/* <div className="right-side__title">
                        {htmlParser(pdpJson?.sectionHeadingProductNotAvailable)}
                      </div> */}
                      {/* <div className="right-side__address">
                        <div>
                          {htmlParser(pdpJson?.descriptionProductNotAvailable)}
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>

                <div className="purchase-design">
                  <div className="purchase-design__left-side">
                    {pdpJson?.designServices.length > 0 &&
                      htmlParser(pdpJson?.designServices[0]?.designPlanTitle)}
                  </div>
                  <div className="purchase-design__right-side">
                    <div className="design-service">
                      {pdpJson?.designServices.length > 0 &&
                        htmlParser(
                          pdpJson?.designServices[0]?.designPlanSectionHeading
                        )}
                    </div>
                    <div className="expert-design">
                      {pdpJson?.designServices.length > 0 &&
                        htmlParser(
                          pdpJson?.designServices[0]?.designPlanDescription
                        )}
                    </div>
                  </div>
                </div>

                <div className="add-installation-noservice">
                  <div className="noservice-title">
                    {pdpJson?.localProTitle}
                  </div>
                  <div className="noservice__right-side">
                    <div className="header">
                      {htmlParser(pdpJson?.localProHeading)}
                    </div>
                    <div className="desc">
                      {htmlParser(pdpJson?.serviceavailable)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ProductAccordionList
          productData={productInfo}
          productInfo={productAnalyticsData.stringProductInfo}
          productSku={sku}
          config={config}
          isDiscontinued={isDiscontinued}
          staticTexts={staticTexts}
          accordionList={pdpJson?.accordianLabels}
          installationSupportLinks={pdpJson?.installationSupportLinks}
          installationDataFromProp={installationDataFromProp}
          designServiceDataFromProp={designServiceDataFromProp}
          businessUnitName={businessUnitName}
          ProductPriceSpiderIncluded_s={ProductPriceSpiderIncluded_s}
          discontinuedProductb={discontinuedProductb}
          ProductRequiredAccessoriesGroupsList={
            ProductRequiredAccessoriesGroupsList
          }
          superSku={superSku}
          currencySign={currencySign}
          productCategory={productCategory}
          designServiceData={designServiceData}
          productServices={productServices}
          productType={productType}
          getZipCode={getZipCode}
          installationData={installationData}
          persona={persona}
          currencyCode={currencyCode}
          locale={locale}
          width={width}
          replaceAddToCart={replaceAddToCart}
          disableRatings={disableRatings}
          replaceAddToCartCtaLink={replaceAddToCartCtaLink}
          replaceAddToCartCtaLabel={replaceAddToCartCtaLabel}
          linkNewTab={linkNewTab}
          disableEcommerce={disableEcommerce}
          isProjectPack={isProjectPack}
          bundleItems={[]}
        />
      </div>
    </div>
  )
}

export default Loader
